
/** 主表配置 */

const mainTable = {
    buttonSetting: {
        /** 是否允许新增按钮 */
        allowAdd: false,
        addFunctionName: 'saveRowByAddOrEdit',
        beforeAddFunctionName: 'beforeAddViewEdit',
        /** 是否允许编辑按钮 */
        allowEdit: false,
        editFunctionName: 'saveRowByAddOrEdit',
        beforeEditFunctionName: 'beforeAddViewEdit',
        /** 是否允许删除按钮 */
        allowDelete: false,
        deleteFunctionName: 'deleteRows',
        /** 是否允许查看按钮 */
        allowView: false,
        beforeViewFunctionName: 'beforeAddViewEdit',
        left: [{
            title: '批量审核',
            type: 'success',
            clickEvent: 'batchAudit'
        }],
    },
    header: {
        title: '班级审核',
        name: 'class'
    },
    table: {
        loading: false,
        maxHeight: 610,
        stripe: true,
        rowStyle: {
            height: '48px;'
        },
        conditionSetting: {
            labelWidth: '120px',
            daterangeWidth: '250px'
        },
        columns: [{
            prop: 'awardPrizeName',
            label: '参评类别名称',
            isSearchCondition: true,
            type: 'select',
            dicData: [
                {
                    label: '朱敬文奖学金-模拟接口',
                    value: 'normal'
                }
            ],
        },{
            prop: 'awardYear',
            label: '参评学年',
            isSearchCondition: true,
            showInTable: false,
            type: 'select',
            dicData: [
                {
                    label: '2018-2019',
                    value: '2018-2019'
                }
            ],
        },{
            prop: 'stuId',
            label: '学号',
            isSearchCondition: false,
            type: 'input'
        },{
            prop: 'name',
            label: '姓名',
            isSearchCondition: false,
            type: 'input'
        },{
            prop: 'sex',
            label: '性别',
            isSearchCondition: false,
            type: 'input'
        },{
            prop: 'class_',
            label: '班级',
            isSearchCondition: true,
            type: 'select',
            dicData: [
                {
                    label: '医学创新创业班',
                    value: '医学创新创业班'
                },{
                    label: '烹饪1805',
                    value: '烹饪1805'
                }
            ],
        },{
            prop: 'college',
            label: '学院',
            isSearchCondition: false,
            type: 'select',
            dicData: [
                {
                    label: '医学院(转化医学研究院)',
                    value: '5022'
                }
            ],
        },{
            prop: 'taskName',
            label: '所处环节',
            isSearchCondition: true,
            type: 'select',
            dicData: [
                {
                    label: '学生申请',
                    value: 'XSSQ'
                },
                {
                    label: '班主任审核',
                    value: 'BZRSH'
                },
                {
                    label: '学院审核',
                    value: 'XYSH'
                },
                {
                    label: '学工处审核',
                    value: 'XGCSH'
                },
                {
                    label: '已完成',
                    value: '已完成'
                }
            ],
        }],
        operation: {
            width: '160',
            operations: [
                {
                    title: '查看表单',
                    clickEvent: 'getForm'
                }
            ]
        },
        tableData: [],
        paging: {
            currentPage: 1,
            pageSizes: [10, 15, 20, 25],
            pageSize: 10,
            total: 0
        },
        reload: 'mainTableReload',
        reloadConditions: {},
        addDefultValue: {}
    }
}
/** ***************************** 主表配置结束  ***************************** */

export default {
    mainTable,

}
